<form [formGroup]="cloneForm" (submit)="save()">
  <h2 mat-dialog-title>
    <i class="fa fa-floppy-disk" aria-hidden="true"></i> Clone Deal
  </h2>
  <div mat-dialog-content>
    <section style="display: grid; gap: 0 15px; grid-template-columns: repeat(4, minmax(0, 1fr));">
      <mat-form-field>
        <mat-label>Periods</mat-label>
        <input matInput type="number" autofocus min="0" step="1" [formControl]="cloneForm.controls.count">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Containers/period</mat-label>
        <input matInput type="number" min="0" step="1" [formControl]="cloneForm.controls.multiple">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Frequency (days)</mat-label>
        <input matInput type="number" min="0" step="1" [formControl]="cloneForm.controls.frequency">
      </mat-form-field>
      <tc-epoch-field placeholder="Start Date"
        [min]="minDate"
        [ctrl]="cloneForm.controls.shipmentStart">
      </tc-epoch-field>
      <mat-hint>No of time periods</mat-hint>
      <mat-hint>No of containers per time period</mat-hint>
      <mat-hint>No of days between time periods</mat-hint>
      <mat-hint>State date of first deal (original deal). If it is a date range, the start date of date range of first deal.</mat-hint>
    </section>
    @if (cloneForm.valid) {
      <cdk-virtual-scroll-viewport itemSize="30" minBufferPx="500" maxBufferPx="1000">
        <table mat-table [dataSource]="dataSource" [trackBy]="getRowId">
          <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
          <ng-container matColumnDef="clone_sequence">
            <th mat-header-cell *matHeaderCellDef mat-sort-header title="Seq">Seq</th>
            <td mat-cell *matCellDef="let row; dataSource:dataSource">
              <div class="text-ellipsis" [title]="row.attributes.clone_sequence">{{row.attributes.clone_sequence}}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="origin_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header title="Pickup Location">Pickup Location</th>
            <td mat-cell *matCellDef="let row; dataSource:dataSource"
              #td [class.tc-cell-editable]="row.attributes.clone_sequence" (click)="editPickupLocation(row, td)">
              <div class="text-ellipsis" [title]="row.origin.name">{{row.origin.name}}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="shipment_dates">
            <th mat-header-cell *matHeaderCellDef mat-sort-header title="Shipment Period">Shipment Period</th>
            <td mat-cell *matCellDef="let row; dataSource:dataSource"
              #td [class.tc-cell-editable]="row.attributes.clone_sequence" (click)="editShipmentDates(row, td)">
              <div class="text-ellipsis" [title]="row.attributes.shipment_dates | epochRange:'utc'">{{row.attributes.shipment_dates | epochRange:'utc'}}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="delivery_dates">
            <th mat-header-cell *matHeaderCellDef mat-sort-header title="Delivery Period">Delivery Period</th>
            <td mat-cell *matCellDef="let row; dataSource:dataSource"
              #td [class.tc-cell-editable]="row.attributes.clone_sequence" (click)="editDeliveryDates(row, td)">
              <div class="text-ellipsis" [title]="row.attributes.delivery_dates | epochRange:'utc'">{{row.attributes.delivery_dates | epochRange:'utc'}}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="fx_rate_bid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header title="FX Bid Rate">FX Bid Rate</th>
            <td mat-cell *matCellDef="let row; dataSource:dataSource">
              <div class="text-ellipsis" title="{{ row.attributes.estimated.sell_currency === 'CAD' ? 1 : row.attributes.fx_rates.rates[row.attributes.estimated.sell_currency]?.[row.attributes.fx_rates_bid_range].bid }} {{ row.attributes.estimated.sell_currency }}/CAD">
                {{ row.attributes.estimated.sell_currency === 'CAD' ? 1 : row.attributes.fx_rates.rates[row.attributes.estimated.sell_currency]?.[row.attributes.fx_rates_bid_range].bid }} {{ row.attributes.estimated.sell_currency }}/CAD
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="fx_rate_ask">
            <th mat-header-cell *matHeaderCellDef mat-sort-header title="FX Ask Rate">FX Ask Rate</th>
            <td mat-cell *matCellDef="let row; dataSource:dataSource">
              <div class="text-ellipsis" title="{{ row.attributes.estimated.buy_currency === 'CAD' ? 1 : row.attributes.fx_rates.rates[row.attributes.estimated.buy_currency]?.[row.attributes.fx_rates_ask_range].ask }} {{ row.attributes.estimated.buy_currency }}/CAD">
                {{ row.attributes.estimated.buy_currency === 'CAD' ? 1 : row.attributes.fx_rates.rates[row.attributes.estimated.buy_currency]?.[row.attributes.fx_rates_ask_range].ask }} {{ row.attributes.estimated.buy_currency }}/CAD
              </div>
            </td>
          </ng-container>
        </table>
      </cdk-virtual-scroll-viewport>
    }
    @if (dataSource.data.length) {
      <div style="padding-top: 20px">
        You are about to create {{dataSource.data.length - 1}} clones of deal {{dealId}}.
        This will result in a total of {{dataSource.data.length}} deals with the same basic deal information.
      </div>
    }
    <tc-inline-editor #inlineEditor></tc-inline-editor>
  </div>
  <mat-progress-bar [mode]="(inProgress$|async) ? 'indeterminate' : undefined"></mat-progress-bar>
  <mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close>Close</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="inProgress$ | async">
      <i class="fa"
        [class.fa-copy]="(inProgress$ | async) !== 'save'"
        [class.fa-spin]="(inProgress$ | async) === 'save'"
        [class.fa-spinner]="(inProgress$ | async) === 'save'"
      ></i>
      Clone
    </button>
  </mat-dialog-actions>
</form>
